



import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth';
import { connectFirestoreEmulator, getFirestore, provideFirestore } from '@angular/fire/firestore';
import { environment } from '../../../environments/environment';

export const firebaseConfig = [
    provideFirebaseApp(() => initializeApp(environment.backend.fire.connection)),
    provideFirestore(() => {
        const firestore = getFirestore();
        if (environment.backend.fire.emulate) {
            connectFirestoreEmulator(firestore, 'localhost', 5001);
        }
        return firestore;
    }),
    provideAuth(() => {
        const auth = getAuth();
        if (environment.backend.fire.emulate) {
            connectAuthEmulator(auth, 'http://localhost:5003', {
                disableWarnings: true
            });
        }
        return auth;
    })
];